import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import styled, { css } from 'styled-components';
import { i as isMobile } from '../../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { u as useTablistContext } from '../TablistContext-Bpw2P1bl.js';
import { T as Tab } from './Tab-DqVERiDB.js';
import { a as TaktIdConsumer } from '../../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { c as createStormTaktId } from '../../TaktIdContext/TaktIdContext.utils-B0CzqlN8.js';

const NavItem = /*#__PURE__*/styled.li.withConfig({
  componentId: "sc-storm-ui-40027066__sc-h00w4x-0"
})(["display:inline-flex;align-items:baseline;position:relative;", ";", " ", ""], ({
  theme,
  $size
}) => css(["font:", ";", ""], $size === 'small' ? theme.font.text.base.default : theme.font.text.medium.default, isMobile(`
      font: ${$size === 'small' ? theme.font.text.base.mobile : theme.font.text.medium.mobile};
      white-space: nowrap;
    `)), ({
  $isActive,
  theme
}) => $isActive && css(["::after{position:absolute;content:'';height:", ";margin:0;bottom:0;left:0;right:0;background:", ";border-radius:", ";}"], theme.tabbedNavigation.highlight.height, theme.tabbedNavigation.highlight.color, theme.tabbedNavigation.highlight.radius), ({
  $isActive,
  $selectable,
  theme
}) => !$isActive && $selectable && css([":hover::after{position:absolute;content:'';height:", ";margin:0;bottom:0;left:0;right:0;background:", ";border-radius:", ";}"], theme.tabbedNavigation.highlight.height, theme.tabbedNavigation.highlight.color, theme.tabbedNavigation.highlight.radius));
NavItem.displayName = 'NavItem';
const TabbedNavigationItem = ({
  id,
  active = false,
  label,
  href,
  onClick,
  renderStart,
  renderEnd,
  taktId,
  taktValue,
  ...rest
}) => {
  const {
    size
  } = useTablistContext();
  return /*#__PURE__*/React__default.createElement(TaktIdConsumer, {
    taktId: taktId,
    taktValue: taktValue,
    fallbackId: createStormTaktId('tabbed-navigation-item')
  }, ({
    getDataTaktAttributes
  }) => /*#__PURE__*/React__default.createElement(NavItem, {
    id: id,
    role: "presentation",
    $size: size,
    $isActive: active,
    $selectable: !!href || !!onClick
  }, renderStart && renderStart(), /*#__PURE__*/React__default.createElement(Tab, _extends({}, rest, {
    active: active,
    dataTaktAttributes: getDataTaktAttributes(),
    href: href,
    label: label,
    onClick: onClick,
    size: size
  })), renderEnd && renderEnd()));
};

export { TabbedNavigationItem as T };
//# sourceMappingURL=TabbedNavigationItem-DH_ZvjAb.js.map
